/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */
import React from "react";
import { classNames } from "@plasmicapp/react-web";

export type Vector2IconProps = React.ComponentProps<"svg"> & {
  title?: string;
};

export function Vector2Icon(props: Vector2IconProps) {
  const { className, style, title, ...restProps } = props;
  return (
    <svg
      xmlns={"http://www.w3.org/2000/svg"}
      fill={"none"}
      viewBox={"0 0 24 24"}
      height={"1em"}
      className={classNames("plasmic-default__svg", className)}
      style={style}
      {...restProps}
    >
      {title && <title>{title}</title>}

      <path
        fill={"currentColor"}
        d={
          "M17.5 17.5c-1.144 0-2.2-.371-3.063-.994v4.931a.438.438 0 0 0 .634.392l2.429-1.215 2.43 1.215a.43.43 0 0 0 .425-.02.44.44 0 0 0 .207-.372v-4.931a5.2 5.2 0 0 1-3.062.994"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M17.5 7.875a4.38 4.38 0 0 0-4.375 4.375 4.38 4.38 0 0 0 4.375 4.375 4.38 4.38 0 0 0 4.375-4.375A4.38 4.38 0 0 0 17.5 7.875"
        }
      ></path>

      <path
        fill={"currentColor"}
        d={
          "M17.5 1.75H2.187a.437.437 0 0 0-.437.438v16.625c0 .241.196.437.438.437h11.374v-3.539a5.22 5.22 0 0 1-1.312-3.461A5.256 5.256 0 0 1 17.5 7c.148 0 .293.01.438.022V2.187a.437.437 0 0 0-.438-.437M9.187 14.875H4.814a.437.437 0 1 1 0-.875h4.375a.437.437 0 1 1 0 .875zm0-3.938H4.814a.437.437 0 1 1 0-.874h4.375a.437.437 0 1 1 0 .874zM11.813 7h-7a.437.437 0 1 1 0-.875h7a.437.437 0 1 1 0 .875"
        }
      ></path>

      <path
        stroke={"currentColor"}
        strokeWidth={"1.75"}
        d={
          "M17.5.875c.726 0 1.313.588 1.313 1.313v4.977a5.26 5.26 0 0 1 3.937 5.085 5.23 5.23 0 0 1-1.313 3.467v5.72c0 .457-.236.878-.62 1.117h-.002a1.31 1.31 0 0 1-1.277.057l-2.038-1.02-2.037 1.02-.006.003a1.315 1.315 0 0 1-1.895-1.177v-1.312H2.188a1.31 1.31 0 0 1-1.313-1.313V2.188c0-.724.587-1.312 1.313-1.312z"
        }
      ></path>
    </svg>
  );
}

export default Vector2Icon;
/* prettier-ignore-end */
